module.exports = __webpack_public_path__ + "static/media/button-yellow.51dcaed6.png";